import { Component, computed, input } from '@angular/core';
import {
  FEATURE_REQUEST_STATUS_LABELS,
  type FeatureRequestStatus,
} from '../../../../shared/models/feature-request.models';

@Component({
  selector: 'app-feature-request-status-badge',
  standalone: true,
  template: `<span [class]="klass()">{{ label() }}</span>`,
})
export class FeatureRequestStatusBadgeComponent {
  readonly status = input.required<FeatureRequestStatus>();
  readonly size = input<'sm' | 'md'>('md');

  readonly label = computed(() => FEATURE_REQUEST_STATUS_LABELS[this.status()]);

  readonly klass = computed(() => {
    const statusClass = `fr-badge--status-${this.status().toLowerCase().replace('_', '-')}`;
    const sizeClass = this.size() === 'sm' ? 'fr-badge--sm' : '';
    return ['fr-badge', statusClass, sizeClass].filter(Boolean).join(' ');
  });
}
